import { useEffect, useState } from "react";
import httpclient from "../../../Utils";

export const useStateSiteData = () => {
  const [states, setStates] = useState([]);
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await httpclient.get(
          "/request-response?requestName=lightspeed/advanced-report/stores"
        );
        const data = response.data;

        const transformedStates = data.map((stateData) => ({
          state: stateData.state,
        }));

        const transformedSites = data.flatMap((stateData) =>
          stateData.stores.map((store) => ({
            ...store,
            state: stateData.state,
          }))
        );

        setStates(transformedStates);
        setSites(transformedSites);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { states, sites, loading, error };
};
